import { render, staticRenderFns } from "./aroma.vue?vue&type=template&id=db0017ec&scoped=true&"
import script from "./aroma.vue?vue&type=script&lang=js&"
export * from "./aroma.vue?vue&type=script&lang=js&"
import style0 from "./aroma.vue?vue&type=style&index=0&id=db0017ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0017ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db0017ec')) {
      api.createRecord('db0017ec', component.options)
    } else {
      api.reload('db0017ec', component.options)
    }
    module.hot.accept("./aroma.vue?vue&type=template&id=db0017ec&scoped=true&", function () {
      api.rerender('db0017ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/aroma.vue"
export default component.exports